import axiosBackEnd from "../config/axios/axios-back-end";

export const getSSOLoggedUsers = async (data) => {
  const url = `/api/ssoLoggedUsers/getSSOLoggedUsers`;
  const response = await axiosBackEnd.get(url,{
    params: data,
  });
  return response.data;
};

export default {
  getSSOLoggedUsers,
};
